"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var interface_1 = require("./interface");
var shared_utils_1 = require("@uip-alpha/shared-utils");
/** 默认json化的response格式处理 */
var responseParse = function (res) { return shared_utils_1.parse(res); };
/**
 * 通用Http请求设计模式 拦截注入模式
 * 1) request方法请求内置的_requestInstance(不同平台注入各自对应的实体)，比如
 * H5:axios/fetch, wxapp：wx.request的promise化, rn：fetch
 * 2) intercept用于前置注入拦截，包括修改config(自定义header，params序列化，增加loading等)，以及返回effect并消除等
 */
var HttpBase = /** @class */ (function () {
    function HttpBase(req) {
        this._interceptors = [];
        this._requestInstance = req;
        /** 默认预设环境 */
        this._env = interface_1.EnvType.ALPHA;
    }
    /**
     *设置针对http的全局环境变量
     */
    HttpBase.prototype.setEnv = function (str) {
        this._env = str;
    };
    /**
     * 设置针对http的全局headers
     */
    HttpBase.prototype.setHeaders = function (headers) {
        this._headers = headers;
    };
    /**
     * @param config
     * @param responseFormat 为处理response返回的默认数据格式
     */
    HttpBase.prototype.request = function (config, responseFormat) {
        // 用于收集intercept返回的Function(即副作用，在request完需要消除的)
        var effects = [];
        /**
         * 将interceptors和request一起添加进管道，依次异步promise化执行
         * 采用composeNext模式，如当前步骤无返回，则拦截完，不继续进行
         *  */
        var promises = this._interceptors.slice(0);
        this._requestInstance && promises.push(this._requestInstance);
        promises.push(function (response) {
            /** 尝试json序列化 */
            var res = responseFormat ? responseFormat(response) : response;
            effects.forEach(function (effect) { return effect(res); });
            return res;
        });
        var requests = shared_utils_1.compose.composeNext(promises, null, function (res) { return typeof res === 'function' && effects.push(res); });
        return requests(config);
    };
    /** 增加拦截 */
    HttpBase.prototype.intercept = function (ipt) {
        this._interceptors.push(ipt);
        return this._interceptors.length - 1;
    };
    /** 删除拦截 */
    HttpBase.prototype.eject = function (index) {
        if (index < 0 || index > this._interceptors.length - 1)
            return;
        this._interceptors.splice(index, 1);
    };
    /** get方法
     * response默认json化处理
     */
    HttpBase.prototype.get = function (config, responseFormat) {
        if (responseFormat === void 0) { responseFormat = responseParse; }
        return this.request(__assign(__assign({}, config), { method: interface_1.HttpMethod.GET }), responseFormat);
    };
    /** post方法
     * response默认json化处理
     */
    HttpBase.prototype.post = function (config, responseFormat) {
        if (responseFormat === void 0) { responseFormat = responseParse; }
        return this.request(__assign(__assign({}, config), { method: interface_1.HttpMethod.POST }), responseFormat);
    };
    /** jsonp方法
     * 均采用get方法模拟(h5平台单独覆盖)
     */
    HttpBase.prototype.jsonp = function (config, responseFormat) {
        if (responseFormat === void 0) { responseFormat = responseParse; }
        return this.get(config, responseFormat);
    };
    return HttpBase;
}());
exports.default = HttpBase;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@uip-alpha/shared-base/dist/http/index.js
// module id = tZ0z
// module chunks = 1